module.exports = __webpack_public_path__ + "img/modelo-hamburgueria.557047a9.png";